var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatsujirushi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.788631, 745.983206)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 794.34375 -140.015625 L 648.9375 5.390625 L 449.671875 -192.078125 L 249.515625 5.390625 L 104.125 -140.015625 L 302.484375 -338.375 L 105.90625 -534.046875 L 252.21875 -680.359375 L 448.78125 -483.78125 L 646.25 -680.359375 L 792.546875 -534.046875 L 595.078125 -338.375 Z M 794.34375 -140.015625 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatsujirushi);
export default __webpack_public_path__ + "static/media/batsujirushi.107d5b61f329cae075c01943ff100603.svg";
export { ForwardRef as ReactComponent };